import store from '@/store/store'
import { errMsg } from '@/utils/supportErrMsg'
import router from '@/router'

export default {
  normalizeFieldErrors (messageBody) {
    let message = ''
    if (messageBody && typeof messageBody === 'object') {
      // Some messages don't have fields attached to them -- these are in non_field_errors
      if (messageBody.non_field_errors && messageBody.non_field_errors.length > 0) {
        message = messageBody.non_field_errors.join('\n')
      }
      for (let key in messageBody) {
        if (key === 'non_field_errors') continue
        let fieldError = messageBody[key]
        if (fieldError instanceof Array) {
          message += `${key}: ${fieldError.join(', ')}\n`
        } else if (typeof fieldError === 'object') {
          message += this.normalizeFieldErrors(fieldError)
        } else {
          message += `${key}: ${fieldError}\n`
        }
      }
    } else if (messageBody && typeof messageBody === 'string') {
      message = messageBody
    }
    return message
  },
  install (Vue) {
    Vue.http.interceptors.push((request, next) => {
      // This is how we properly catch errors from the server
      next((response) => {
        // If it's a 400 Bad Request response from the API, and if the body exists, build an error message string
        let errorTitle = ''
        let errorMessage = ''
        let duration = 0
        const suppressedEndpoints = ['populate']
        if (response && response.url && shouldSuppressErr(suppressedEndpoints, response.url)) return
        if (response && String(response.status) === '400' && response.body && Object.keys(response.body).length > 0) {
          errorTitle = 'Error'
          errorMessage = this.normalizeFieldErrors(response.body)
          duration = 10000
          if (errorMessage.length < 1) {  // Handle case where no conditions are met
            errorMessage = 'An unknown error occurred'
          }
          // TODO: this interceptor is only for the 400 error code. Create a separate interceptor for others
        } else if (response && (parseInt(response.status) >= 500 && parseInt(response.status) < 600)) {
          const se = 'Server Error'
          errorTitle = response.statusText && typeof response.statusText === 'string' ? response.statusText : se
          errorMessage = response.body && typeof response.body === 'string' && !response.body.includes('<!DOCTYPE html>') ? response.body : se
          errorMessage = errorMessage + '. Please try again.' + errMsg
          // TODO: this works fine, but again, it should be in its own interceptor
        } else if (response && (!response.status || String(response.status) === '0')) {
          if (navigator && Navigator.prototype.hasOwnProperty('onLine') && !navigator.onLine) {   // Check internet connection
            errorTitle = 'No Connection'
            errorMessage = 'Please check your internet connection and try again.'
          } else {
            if (request.crossOrigin && !request.body && request.method === 'GET' && router.history.current.name === 'Login') return
            errorTitle = 'Error'
            errorMessage = 'An unknown error occurred. Please try again.' + errMsg
          }
        }
        // Mixpanel notify
        if (typeof Vue.mixpanel !== 'undefined' && errorTitle.length && errorMessage.length) {
          let user = store.getters.getUser
          let instance = store.getters.getActiveInstance
          let body = Vue.mixpanel.responseBodyToMixpanelValue(response.body)
          Vue.mixpanel.track(`Error`, {
            title: errorTitle,
            error: errorMessage,
            url: request.url,
            distinct_id: user.username,
            instance: instance.url,
            $email: user.email,
            statusText: JSON.stringify(response.statusText),
            statusCode: JSON.stringify(response.status),
            body
          })
        }
        // UI notify
        if (response.body.code === 'PNDUP') return
        if (!Vue.prototype.$badRequestNotif && errorTitle.length && errorMessage.length) {
          Vue.prototype.$badRequestNotif = Vue.prototype.$notify
          Vue.prototype.$badRequestNotif.error({
            title: errorTitle,
            message: errorMessage,
            duration: duration || 0
          })
          setTimeout(() => {
            Vue.prototype.$badRequestNotif = null
          }, 10000)
        }
      })
    })
  }
}

/**
 * Determines whether or not an error should be suppressed, based on the contents of suppressedEndpoints
 * @param suppressedEndpoints   Endpoints that should be suppressed
 * @param url                   The response url
 * @return {boolean}
 */
function shouldSuppressErr (suppressedEndpoints, url) {
  for (let i = 0; i < suppressedEndpoints.length; i++) {  // Break out of function if response.url contains endpoint for which error should be suppressed
    const parsedUrl = url.split('/')
    let endpoint = parsedUrl[parsedUrl.length - 1]
    if (endpoint && endpoint.includes('?')) endpoint = endpoint.split('?')[0]
    if (url && endpoint === suppressedEndpoints[i]) return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/plugins/interceptors/bad_request.js